var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { dispatchGtmEvent } from './gtm';
export var MOBILE_HEADER_THRESHOLD = 1024;
export function isMobile() {
    return window.innerWidth < MOBILE_HEADER_THRESHOLD;
}
var consoleProxy = window.console;
if (process.env.MIX_WP_ENV === 'production') {
    consoleProxy = {};
    Object.keys(window.console).forEach(function (key) {
        if (typeof window.console[key] === 'function') {
            consoleProxy[key] = function () {
                if (window.WA_DEBUG || document.cookie.indexOf('WA_DEBUG=1') >= 0) {
                    window.console[key].apply(window, arguments);
                }
            };
        }
        else {
            Object.defineProperty(consoleProxy, key, {
                get: function () { return window.console[key]; },
                set: function (v) { window.console[key] = v; },
            });
        }
    });
}
export var dev = consoleProxy;
export function initHiddenSecrets() {
    deobfuscateEmails();
    var hiddenEmailEls = [].slice.call(document.querySelectorAll('[data-hidden-secret="email"]'));
    if (!hiddenEmailEls.length) {
        return;
    }
    var catpchaDialogEl = document.getElementById('captchaDialogEl');
    var closeButtonEl = catpchaDialogEl.querySelector('.closeButton');
    var recaptchaSiteKey = catpchaDialogEl.dataset.siteKey;
    closeButtonEl === null || closeButtonEl === void 0 ? void 0 : closeButtonEl.addEventListener('click', function () {
        catpchaDialogEl.close();
    });
    hiddenEmailEls.forEach(function (el) {
        el.addEventListener('click', function (e) {
            e.preventDefault();
            catpchaDialogEl.showModal();
        });
    });
    performRecaptchaCheck();
    grecaptcha.ready(function () {
        grecaptcha.render('captcha-container', {
            'sitekey': recaptchaSiteKey,
            'callback': performRecaptchaCheck,
        });
    });
    function performRecaptchaCheck(userResponse) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var resp, err_1, removeEls_1, _loop_1, _i, hiddenEmailEls_1, el;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        resp = null;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch("/wp-json/wa-theme/v1/handleHiddenSecrets?userResponse=".concat(userResponse || ''))];
                    case 2: return [4 /*yield*/, (_b.sent()).json()];
                    case 3:
                        resp = _b.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _b.sent();
                        console.warn("Failed to validate hidden secret", err_1);
                        return [3 /*break*/, 5];
                    case 5:
                        if (catpchaDialogEl.open) {
                            catpchaDialogEl.close();
                        }
                        // Match and replace elements with e-mail links if there are any
                        if ((_a = resp === null || resp === void 0 ? void 0 : resp.links) === null || _a === void 0 ? void 0 : _a.length) {
                            removeEls_1 = [];
                            _loop_1 = function (el) {
                                if (el.dataset.hiddenRefId) {
                                    var link = resp.links.find(function (l) { return l.id === parseInt(el.dataset.hiddenRefId); });
                                    if (link) {
                                        var div = document.createElement('div');
                                        div.innerHTML = link.html;
                                        var linkEl = deobfuscateEmailLink(div.querySelector('a'));
                                        el.replaceWith(linkEl);
                                    }
                                }
                            };
                            for (_i = 0, hiddenEmailEls_1 = hiddenEmailEls; _i < hiddenEmailEls_1.length; _i++) {
                                el = hiddenEmailEls_1[_i];
                                _loop_1(el);
                            }
                            hiddenEmailEls = hiddenEmailEls.filter(function (el) { return !removeEls_1.includes(el); });
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
}
function deobfuscateEmails() {
    [].slice.apply(document.querySelectorAll('.email-link[data-link]'))
        .forEach(function (linkEl) { return deobfuscateEmailLink(linkEl); });
}
function deobfuscateEmailLink(linkEl) {
    var device = null;
    if (navigator.userAgent.match(/iPhone|iPad/i)) {
        device = 'apple';
    }
    else if (navigator.userAgent.match(/Android/i)) {
        device = 'android';
    }
    var realEmail = linkEl.dataset.link.split('').map(function (char) {
        switch (char) {
            case '@':
                return '.';
            case '.':
                return '@';
            default:
                return char;
        }
    }).reverse().slice(5, -4).join('');
    linkEl.innerHTML = '';
    linkEl.setAttribute('data-real-link', realEmail);
    linkEl.setAttribute('data-real-email-name', realEmail.split('@')[0]);
    linkEl.setAttribute('data-real-email-domain', realEmail.split('@')[1]);
    if (realEmail.length > 20) {
        linkEl.classList.add('is--long');
    }
    if (device === 'apple') {
        linkEl.addEventListener('click', function (event) {
            event.preventDefault();
            var nw = window.open("mailto:".concat(realEmail));
            dispatchGtmEvent('AC.Interaction.Email.click', { email: realEmail });
            setTimeout(function () { return nw.close(); }, 500);
        });
    }
    else {
        var anchor_1 = Object.assign(document.createElement('a'), {
            href: "mailto:".concat(realEmail),
            target: '_blank',
        });
        linkEl.addEventListener('click', function (event) {
            event.preventDefault();
            document.body.appendChild(anchor_1);
            anchor_1.click();
            dispatchGtmEvent('AC.Interaction.Email.click', { email: realEmail });
            setTimeout(function () { return anchor_1.parentElement.removeChild(anchor_1); }, 500);
        });
    }
    return linkEl;
}
